export const CREATE_STRIPE_PAYMENT = 'src/Stripe/CREATE_STRIPE_PAYMENT'

export const CREATE_STRIPE_PAYMENT_FAILURE =
  'src/Stripe/CREATE_STRIPE_PAYMENT_FAILURE'

export const GET_PRICE_INFO = 'src/Stripe/GET_PRICE_INFO'
